import { render, staticRenderFns } from "./RglFile.vue?vue&type=template&id=02b14516&scoped=true"
import script from "./RglFile.vue?vue&type=script&lang=js"
export * from "./RglFile.vue?vue&type=script&lang=js"
import style0 from "./RglFile.vue?vue&type=style&index=0&id=02b14516&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b14516",
  null
  
)

export default component.exports